import { SvgIconProps } from './icon-props';

export default function CheckmarkFill({
	height = 32,
	width = 32,
	fill = '#000',
	className,
}: SvgIconProps) {
	return (
		<svg
			id="Icons"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 32"
			fill={fill}
			className={className}
		>
			<path d="M16,1C7.72,1,1,7.72,1,16s6.72,15,15,15,15-6.72,15-15S24.28,1,16,1ZM24.43,10.46l-9.98,12.34c-.18.22-.44.35-.72.37-.02,0-.04,0-.05,0-.26,0-.52-.1-.71-.29l-5.33-5.33c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l4.54,4.54,9.29-11.47c.35-.43.98-.5,1.41-.15.43.35.5.98.15,1.41Z" />
		</svg>
	);
}
